import dayjs from 'dayjs';

// The report APIs return one row per order day, with order_date as YYYY-MM-DD.
export const dateColumn = {
  id: 'order_date',
  label: 'Date',
  render: (row) => (row.order_date ? dayjs(row.order_date).format('DD/MM/YYYY') : '-'),
};
